import { createTheme, ThemeOptions } from "@mui/material"
import themeComponents from "./theme-components"

const colors = {
  primaryMain: "#F9FAFB",
  primaryContrastText: "#0F172A",
  secondaryMain: "#1E293B",
  secondaryContrastText: "#ffffff",
  errorMain: "#FA897B",
  successMain: "#D0E6AS",
  warningMain: "#FFDD94",
  infoMain: "#B6E3CE",
  textPrimary: "#fff",
  textSecondary: "#D1D5DB",
  textDisabled: "#6B7280",
  divider: "#374151",
  backgroundDefault: "#ffffff",
  sidebarMain: "#334155",
  actionHover: "#E2E8F0",
  actionSelected: "#475569",
  tableFontSize: "0.875rem"
}

const darkTheme: ThemeOptions = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: colors.primaryMain,
      contrastText: colors.primaryContrastText
    },
    secondary: {
      main: colors.secondaryMain,
      contrastText: colors.secondaryContrastText
    },
    error: {
      main: colors.errorMain
    },
    success: {
      main: colors.successMain
    },
    info: {
      main: colors.infoMain
    },
    warning: {
      main: colors.warningMain
    },
    background: {
      default: "#0F172A",
      paper: "#090e1a"
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled
    },
    divider: colors.divider,
    action: {
      hover: colors.divider,
      selected: "#4B5563"
    },
    neutral: {
      main: "#A1A1AA",
      contrastText: colors.backgroundDefault
    },
    sidebar: {
      main: colors.sidebarMain,
      contrastText: "#F1F5F9",
      hover: colors.sidebarMain,
      submenuBackground: colors.secondaryMain,
      active: colors.sidebarMain
    },
    grey: {
      500: colors.textDisabled
    },
    table: {
      headerColor: colors.primaryMain,
      headerBackground: colors.sidebarMain,
      color: colors.primaryMain,
      background: colors.sidebarMain,
      active: colors.actionSelected,
      border: colors.actionSelected,
      fontSize: "0.875rem"
    },
    scrollbar: {
      thumb: colors.actionSelected,
      track: colors.sidebarMain
    }
  },

  typography: {
    fontFamily: `'Poppins',"Lato", "Inter",Roboto, sans-serif`,
    h1: { fontSize: "1.75rem", fontWeight: 700, lineHeight: 1.5 },
    h2: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.15rem", fontWeight: 600, lineHeight: 1.3 },
    h5: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.4 },
    subtitle1: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.3 },
    subtitle2: { fontSize: "0.625rem", fontWeight: 400, lineHeight: 1.2 },
    caption: { fontSize: "0.5rem", fontWeight: 400, lineHeight: 1.1 }
  },

  components: themeComponents
})

export default darkTheme
